import { jsx as _jsx } from "react/jsx-runtime";
import { UI_DATE_FORMAT } from '../../../constants/statics';
import React, { Component } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import MaskedInput from 'react-text-mask';
import classnames from 'classnames/bind';
import styles from '../styles.scss';
import createAutoCorrectionDatePipe from './createAutoCorrectionDatePipe';
const cx = classnames.bind(styles);
const dateSpecificMask = [
    /[0-1]/,
    /\d/,
    '/',
    /[0-3]/,
    /\d/,
    '/',
    /[1-2]/,
    /\d/,
    /\d/,
    /\d/,
];
const getWrappedMaskedInput = (placeholder, disabled) => class WrappedMaskedInput extends Component {
    static propTypes = {
        onChange: PropTypes.func.isRequired,
        onFocus: PropTypes.func.isRequired,
        onKeyUp: PropTypes.func.isRequired,
        onClick: PropTypes.func.isRequired,
        onBlur: PropTypes.func.isRequired,
    };
    static defaultProps = {
        placeholder: UI_DATE_FORMAT,
    };
    focus = () => {
        this.input.inputElement.focus();
    };
    render() {
        const inputProps = _.omit(this.props, 'focus');
        return (_jsx(MaskedInput, { disabled: disabled, ref: el => (this.input = el), className: cx('masked-input'), mask: dateSpecificMask, pipe: createAutoCorrectionDatePipe(), placeholder: placeholder, keepCharPositions: true, type: 'tel', ...inputProps }));
    }
};
export default getWrappedMaskedInput;
//# sourceMappingURL=getWrappedMaskedInput.js.map